import { Tokens } from '~/utils/constants';

export const findTokenByPartialKey = (partialKey: string): Tokens | undefined => {
  const normalizeString = (str: string) =>
    str
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/([a-z])([A-Z])/g, '$1$2')
      .split('')
      .sort()
      .join('');

  const normalizedSearch = normalizeString(partialKey);

  const tokens = Object.values(Tokens);

  return tokens.find((token) => {
    const normalizedToken = normalizeString(token);
    return normalizedToken === normalizedSearch;
  });
};

export const splitCamelCase = (text: string): string => {
  return text.replace(/([a-z])([A-Z])/g, '$1 $2');
};
